import React, { useMemo } from "react";
import styles from "./style.module.css";
import type { IndexMember } from "~types/types";
import {
  LocalizedText,
  type TranslatedMessageType,
} from "~utils/i18n/translate";

// TODO: submit {TRAN <GO>} request for new labels
const totalMembersLabel: TranslatedMessageType = {
  id: "totalMembers",
  defaultMessage: "Total Members",
};
const membersUpLabel: TranslatedMessageType = {
  id: "membersUp",
  defaultMessage: "Members Up",
};
const membersDownLabel: TranslatedMessageType = {
  id: "membersDown",
  defaultMessage: "Members Down",
};

function calculateIndexMovers(members: IndexMember[]) {
  return members.reduce(
    (acc, memberData) => {
      if (!memberData) return acc;

      const change = memberData.percentChange1Day;

      if (change > 0) {
        return { ...acc, membersUp: acc.membersUp + 1 };
      } else if (change < 0) {
        return { ...acc, membersDown: acc.membersDown + 1 };
      }

      return { ...acc, membersUnchanged: acc.membersUnchanged + 1 };
    },
    { membersUp: 0, membersDown: 0, membersUnchanged: 0 }
  );
}

function Mover({
  label,
  value,
}: {
  label: TranslatedMessageType;
  value: number;
}) {
  return (
    <div className={styles.mover}>
      <span className={styles.moverTitle}>
        <LocalizedText value={label} />
      </span>
      <span className={styles.moverValue}>{value}</span>
    </div>
  );
}

export default function IndexMovers({
  indexMembers,
}: {
  indexMembers: IndexMember[];
}) {
  const indexMovers = useMemo(
    () => calculateIndexMovers(indexMembers),
    [indexMembers]
  );

  return (
    <div className={styles.indexMovers}>
      <Mover label={totalMembersLabel} value={indexMembers.length} />
      <Mover label={membersUpLabel} value={indexMovers.membersUp} />
      <Mover label={membersDownLabel} value={indexMovers.membersDown} />
    </div>
  );
}
